export enum UserRoles {
  Agent = 1,
  User = 2,
  SystemAdministrator = 3,
  OnBehalfOf = 5,
  TitleEscrowUser = 7,
  TitleUser = 10,
  EscrowUser = 11,
  CPLOnlyUser = 12,
  StaffAdministrator = 13,
}

export enum UserRoleTypes {
  Agent = 100,
  Staff = 101,
}

export enum UserRoleTypeNames {
  Agent = 'Agent',
  Staff = 'Staff',
}

export enum UserAccessKeyStatus {
  Created = 0,
  Activated = 1,
  Revoked = 2,
}

export enum ContactType {
  LENDER = 'Lender',
  CLOSING_ATTORNEY = 'Closing Attorney',
}

export const addSignatureMsg = 'Click and drag your mouse to create your signature in the area below';
export const agreementMsg = ' I accept the terms and conditions for the AgentNet eSignature Agreement';
export const cautionText =
  'The affixing of an electronic signature by a title agent upon a policy form is done by direction' +
  ' of the agent and is the responsibility of the agent. No liability is assumed by First American or' +
  ' its affiliates regarding regulatory compliance.';
export const uploadSignatureMsg =
  'Please sign your name on a blank white piece of paper and take a photo or scan it. Upload the image in JPG, PNG, GIF format below.';

export const AGENCY_SUPPORT_EMAIL = 'AgencySupport@firstam.com';

export const PREFERRED_OFFICE_EMPTY_STATE_FA = {
  title: 'No Offices Found',
  description: "We couldn't find any offices associated with your firm.",
  supportTextPrefix: 'Please call the Agency Service Center (ASC) at',
  supportTextMiddle: 'or email',
  supportTextSuffix: 'for assistance.',
};

export const PREFERRED_OFFICE_EMPTY_STATE_AGENT = {
  title: 'Preferred Offices Unavailable',
  description: "Preferred Offices isn't available for First American users.",
};

export const USER_STATUS_NOT_ACTIVATED = 'Not Activated';
export const USER_STATUS_TYPE_NOT_ACTIVATED = 'NotActivated';
export const USER_STATUS_ACTIVE = 'Active';
export const USER_STATUS_DISABLED = 'Disabled';
export const USER_STATUS_INACTIVE = 'Inactive';
export const USER_STATUS_TYPE_INACTIVE = 'InActive';

export const PROFILE_SAVE_OK_STATUS = '200';
export const PROFILE_SAVE_UNSET_STATUS = 'undefined';
export const PROFILE_SAVE_SECTION_LABELS: Record<string, string> = {
  OfficeResponse: 'Office Information',
  EmailResponse: 'Service Order Email Notification',
  BopsResponse: 'Title Commitment Download Preferences',
  StaffContactResponse: 'Contact Information',
};
